import { ACTION_TYPES } from '~/core/constants'

const { ROOM, ROOM_SETTINGS } = ACTION_TYPES
const initialState = {
  customRoomName: '',
  personalRoom: {
    name: '',
    fullName: '',
    url: '',
    password: ''
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ROOM.SET_CUSTOM_ROOM_NAME: {
      return {
        ...state,
        customRoomName: action.payload
      }
    }
    case ROOM.SET_PERSONAL_ROOM: {
      return {
        ...state,
        personalRoom: action.payload
      }
    }
    case ROOM_SETTINGS.SET_PERSONAL_ROOM_PASSSWORD: {
      return {
        ...state,
        personalRoom: {
          ...state.personalRoom,
          password: action.payload
        }
      }
    }
    default:
      return state
  }
}

export default reducer
